export default {
  props: {
    ignoreEmpty: {
      type: Boolean,
      default: true
    },

    language: {
      type: String,
      default: 'javascript'
    },

    value: {
      type: String,
      default: undefined
    },
  },

  methods: {
    fromValue(value) {
      if (value === undefined || value === null) {
        return value;
      }

      if (this.ignoreEmpty && value === '') {
        // console.log('ignoreEmpty');
        value = undefined;
      }

      // console.log('Returning', value);
      return value;
    }
  }
}
